import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function CalculationsOfTaxLiabilityTable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const calculationOfTaxLiabilityRows = [{
    text: 'Number of associated companies',
    field_1: {
      name: 'number_of_associated_companies',
      editable: true
    },
    field_2: {
      name: 'number_of_associated_companies'
    }
  }, {
    text: 'Corporation Tax liability',
    field_1: {
      name: 'corporation_tax_liability_1'
    },
    field_2: {
      name: 'corporation_tax_liability_2'
    }
  }, {
    text: 'Marginal Relief',
    field_1: {
      name: 'marginal_relief_1'
    },
    field_2: {
      name: 'marginal_relief_2'
    }
  }, {
    text: 'Use of old RDEC - Step 1',
    field: {
      name: 'use_of_old_rdec_step_1_value'
    },
    shouldDisplay: claim.rate_types_qualified_for.rdec
  }, {
    text: 'Use of RDEC Merged Scheme - Step 1',
    field: {
      name: 'use_of_rdec_merged_scheme_step_1_value'
    },
    shouldDisplay: claim.rate_types_qualified_for.merge_type
  }, {
    text: 'Tax already paid',
    field_1: {
      name: 'tax_already_paid',
      editable: true
    },
    field_2: {
      name: 'tax_already_paid'
    }
  }, {
    text: 'Refund',
    field_1: {
      name: 'refund_1'
    },
    field_2: {
      name: 'refund_2'
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - (additional) Tax refund due',
    field: {
      name: 'benefit_additional_tax_refund_due'
    }
  }, {
    text: 'Corporation Tax payable',
    field_1: {
      name: 'corporation_tax_payable_1'
    },
    field_2: {
      name: 'corporation_tax_payable_2'
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - Tax reduction',
    field: {
      name: 'benefit_tax_reduction'
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Calculation of tax liability",
    rows: calculationOfTaxLiabilityRows
  });
}